import { useRef, useEffect } from 'react';

// We can avoid adding ref value to the array dependencies of useEffect where it's used
export const useIsComponentMounted = (): boolean => {
  const isMountRef = useRef(false);

  useEffect(() => {
    isMountRef.current = true;
  }, []);

  return isMountRef.current;
};
